<template>
  <div>
    <el-select
      v-model="channelId"
      :disabled="disabled"
      :placeholder="placeholder"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("../util");

export default {
  data() {
    return {
      channelId: "", // 当前被选择的渠道id
      availableChannels: [], // 所有可用的渠道
    };
  },

  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },

    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },

    // 是否支持选择“全渠道”
    enableFullChannels: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    options() {
      let options = [];

      for (let c of this.availableChannels) {
        options.push({
          id: c.id,
          name: c.name,
        });
      }

      if (this.enableFullChannels) {
        options.push({
          id: 0,
          name: "全渠道",
        });
      }

      return options;
    },
  },

  created() {
    this.loadAvailableChannels();
  },

  watch: {
    channelId: {
      handler(newValue, oldValue) {
        this.$emit("change", newValue, oldValue);
      },
    },
  },

  methods: {
    /**
     * 查询渠道集合
     */
    async loadAvailableChannels() {
      let resData = (
        await axios.get(`${util.getBackendApiBase()}/v1/getChannelList`, {
          headers: {
            token: util.getLoginUserToken(),
          },
        })
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      for (let e of resData.data.channels) {
        this.availableChannels.push({
          id: e.id,
          name: e.name,
        });
      }

      /*
      // 自动选择一个渠道
      if (this.availableChannels.length > 0) {
        this.channelId = this.availableChannels[0].id;
      }
      */

      // 抛出准备就绪事件
      this.$emit("ready");
    },
  },
};
</script>